import gql from 'graphql-tag'
export const fetchAddCompleteLayerMutation = gql(`
mutation ($id: Int , $new_qty: Int, $product_id: Int ,$operate_flag: String!) {
    freeBeerCart(
        input:{
            id: $id,
            new_qty: $new_qty,
            product_id: $product_id,
            operate_flag: $operate_flag
        }
    ){
        success_message
        error_message
        cart_id
    }
}`)
